import React from 'react';
import { motion } from 'framer-motion';
import { Utensils, GraduationCap, HeartPulse, Droplets } from 'lucide-react';

const WORKSHOP_IMG = "assets/img/WhatsApp-Image-2026-03-23-at-4.16.11-PM-1.jpeg";
const GARDEN_IMG = "assets/img/WhatsApp-Image-2026-03-23-at-4.12.00-PM.jpeg";

const programs = [
  {
    icon: Utensils,
    title: "Community Feedings",
    description: "Providing nutritious meals to families in need. Our initiative delivers fresh food to families in Temecula, CA and thousands of meals to women and children in the Western Region of Ghana.",
    color: "bg-primary/10 text-primary"
  },
  {
    icon: GraduationCap,
    title: "Life Skills Training",
    description: "Our training program addresses social, psychological, and cognitive factors through curriculum designed to enhance personal competence and mental wellness.",
    color: "bg-secondary/10 text-secondary"
  },
  {
    icon: HeartPulse,
    title: "Community Mental Health",
    description: "Treating the whole person with a holistic approach. We address underlying issues that trigger addiction and mental illness, helping maintain balance in career, social, and family life.",
    color: "bg-accent/10 text-accent"
  },
  {
    icon: Droplets,
    title: "Clean Water Initiative",
    description: "Improving healthcare infrastructure by providing clean water access, eliminating chronic illnesses and transmittable diseases fueled by contaminated water sources.",
    color: "bg-primary/10 text-primary"
  }
];

export default function Programs() {
  return (
    <section id="programs" className="py-16 sm:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <p className="text-primary font-medium tracking-[0.2em] uppercase text-sm mb-4">What We Do</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground">
            Other <span className="text-primary italic">Programs</span> &amp; Services
          </h2>
        </motion.div>

        {/* Featured images */}
        <div className="grid md:grid-cols-2 gap-6 mb-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <img src={WORKSHOP_IMG} alt="Community education workshop" className="w-full h-64 object-cover" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="rounded-2xl overflow-hidden shadow-lg"
          >
            <img src={GARDEN_IMG} alt="Community garden initiative" className="w-full h-64 object-cover" />
          </motion.div>
        </div>

        {/* Program cards */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {programs.map((program, i) => (
            <motion.div
              key={program.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="bg-card rounded-xl p-6 shadow-sm border border-border hover:shadow-md transition-all hover:-translate-y-1 duration-300"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mb-4 ${program.color}`}>
                <program.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground mb-2">{program.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{program.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}